import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import UploadDocIcon from '../assets/imgs/upload-documents-icon.svg'
import WorkLicenseModal from './WorkLicenseModal'
import CreateServiceModal from './CreateServiceModal'
import { TextField } from '@mui/material'
import { saveOrUpdateDataById, updateDataById } from '../apis/generalApis'
import FeaturedStylistCard from '../Client/Components/Cards/FeaturedStylistCard'
import FeaturedServiceCard from '../components/Cards/FeaturedServiceCard'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  width: '400px',
  borderRadius: '16px',
  textAlign: 'center',
}

const NewServiceModal = ({
  handleNewServiceModal,
  newServiceModal = false,
  component = '',
  service,
  formData = new FormData(),
  selectedSubService,
  setServiceData,
  getStylistServices,
  handleCreateServiceModal,
  // handleAddOrEditSkillsModal,
}) => {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  const [isLoading, setIsLoading] = React.useState(false)

  const handleAddNewService = async (e) => {
    e.preventDefault()
    formData.append('stylist_id', user?.id)
    formData.append('user_id', user?.id)
    setIsLoading(true)
    let result = await saveOrUpdateDataById('stylist-add-service', formData)
    setIsLoading(false)
    if (result?.success === true) {
      handleNewServiceModal(false)
      setServiceData(null)
      if (component === 'sign-up') {
        navigate('/dashboard')
        return
      }
      getStylistServices()
      // handleCreateServiceModal()
      // if (handleAddOrEditSkillsModal) {
      //   handleAddOrEditSkillsModal(false)
      // }
      Swal.fire({
        title: 'Service Created Successfully!',
        timer: 3000,
        icon: 'success',
        confirmButtonColor: '#2597F6',
      })
    }
  }

  const mangeServicePrimaryImageUrl = (primary_image) => {
    if (primary_image && typeof primary_image === 'string') {
      return primary_image
    } else if (primary_image && typeof primary_image === 'object') {
      return URL.createObjectURL(primary_image)
    } else return ''
  }

  return (
    <div>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 2000,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={newServiceModal}
        onClose={() => handleNewServiceModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form onSubmit={handleAddNewService}>
            <div className="row">
              <div className="col-12">
                <h3 className="fs-24 mb-3 fw-bold">New Service</h3>
                <div className="feature-service-card">
                  <img
                    src={mangeServicePrimaryImageUrl(service?.primary_image)}
                    alt="Service Image"
                    height={240}
                    style={{ borderRadius: '20px', objectFit: 'cover' }}
                    className={`w-100 featured-service-card-image`}
                  />
                  <div
                    className="text-center feature-service-card-desc py-1 position-relative py-2"
                    style={{ width: '100%' }}
                  >
                    <p
                      className="font-weight-bold m-0 text-capitalize"
                      style={{
                        wordBreak: 'break-all',
                        padding: '0 15px',
                        fontSize: '25px',
                      }}
                    >
                      {selectedSubService?.name ?? 'No service title'}
                    </p>
                    <p className="fs-16 m-0 opacity-50">
                      {selectedSubService?.provider + ' service providers'}
                    </p>
                  </div>
                </div>
                <Button
                  disableElevation
                  id="btn-primary-no-shadow"
                  variant="contained"
                  className="pointer mt-5"
                  type="submit"
                  fullWidth={true}
                >
                  Add Service
                </Button>
              </div>
            </div>
          </form>
        </Box>
      </Modal>
      {/* <CreateServiceModal
        handleCreateServiceModal={handleCreateServiceModal}
        createServiceModal={createServiceModal}
      /> */}
    </div>
  )
}

export default NewServiceModal
